<template>
  <div class="order-panel">
    <nav-bar :border="false" :left-arrow="true" @click-left="pageBack" title="历史订单"></nav-bar>

    <template v-if="items.length">
      <div class="order-item" v-for="item in items" :key="item.orderId" @click="go(item.orderId,item.store)">
        <div v-if="item.store" class="order-item-content">
          <h3>{{item.store.split("(")[0]}}</h3>
          <div class="order-item-text">
            {{item.orderDate}}
          </div>
        </div>
        <div v-if="item.store" class="order-item-price">
          ￥{{item.orderAmount}}
        </div>
        <div v-if="item.store" class="order-item-arrow">
          <img src="~@/assets/ic_right_arrow_dark.png" alt="">
        </div>
      </div>
    </template>
    <noList v-else></noList>
  </div>
</template>

<script>
import {getOrder} from '@/api'
import noList from '@/components/noList'
import {NavBar} from 'vant'
export default {
  data(){
    return{
      items:[]
    }
  },
  components:{
    noList,
    NavBar
  },
  async created(){
    const res = await getOrder();
    if(res.code===0){
      this.items = res.data
    }
  },
  methods:{
    pageBack(){
      window.history.back();
    },
    go(id,name){
      this.$router.push({
        path:`/orderDetail?id=${id}&name=${name}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-panel {
  min-height: 100vh;
  background: linear-gradient(180deg, #f5f7fa 0%, #e4e7ed 100%);
}

::v-deep .van-nav-bar {
  background: #fff;

  .van-nav-bar__title {
    color: #333 !important;
    font-size: 28px;
  }

  .van-icon {
    color: #333 !important;
  }
}

.order-item {
  background: #fff;
  border-radius: 20px;
  padding: 28px 24px;
  margin: 0 24px 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;

  &:active {
    transform: scale(0.98);
  }

  .order-item-content {
    flex: 1;
    min-width: 0;

    h3 {
      font-size: 28px;
      font-weight: 600;
      margin: 0 0 10px;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .order-item-text {
    font-size: 22px;
    color: #909399;
  }

  .order-item-price {
    font-size: 30px;
    font-weight: 700;
    color: #e6a23c;
    margin: 0 16px;
    white-space: nowrap;
  }

  .order-item-arrow {
    width: 36px;
    flex-shrink: 0;

    img {
      width: 100%;
      opacity: 0.4;
    }
  }
}
</style>
